import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalltoactionService {  
  private component: Subject<any>;
  private change: Subject<any>;

  constructor() {
    if(!this.component) {
      this.component = new Subject<any>();
    }

    if(!this.change) {
      this.change = new Subject<any>();
    }
  }  

  add(tt: any) {
    this.component.next(tt);
    this.change.next("add");
  }

  remove() {
    this.component.next(null);
    this.change.next("remove");
  }

  redraw() {
    this.change.next("redraw");
  }

  getComponents() {
    return this.component.asObservable();
  }

  getChanges() {
    return this.change.asObservable();
  }
}
